export const strToDate = (dtStr) => {
  const dateParts = dtStr.split('/')
  const timeParts = dateParts[2].split(' ')[1].split(':')
  dateParts[2] = dateParts[2].split(' ')[0]
  return new Date(
    +dateParts[2],
    dateParts[1] - 1, //0 based months
    +dateParts[0],
    timeParts[0],
    timeParts[1]
  )
}

export const snakeToPascal = (value) => {
  const words = value.split('_')
  return words.length > 1 ||
    words[0].length > 2 ||
    ['a', 'e', 'i', 'o', 'u'].some((vowel) => words[0].includes(vowel))
    ? words.map((str) => upperFirst(str)).join(' ')
    : words.map((str) => str.toUpperCase()).join(' ')
}

const upperFirst = (value) =>
  value.slice(0, 1).toUpperCase() + value.slice(1, value.length)
